<template>
  <div>
    <p class="fs-16 fw-500 mb-4">
      {{ $bct('Search for your provider by name') }}
    </p>
    <v-autocomplete
      v-model="selectedProvider"
      v-model:search="providerQuery"
      @update:model-value="setProvider($event)"
      :aria-label="$bct('Search by location name')"
      :items="searchedProviders"
      :placeholder="$bct('Search')"
      class="mb-4"
      color="secondary"
      data-testid="provider-selector-autocomplete"
      density="compact"
      item-title="name"
      item-value="id"
      prepend-inner-icon="search"
      variant="filled"
      auto-select-first
      hide-details
      hide-no-data
      no-filter
      return-object
      rounded
    >
      <template #item="{ item, props: listItemProps }">
        <v-list-item
          v-bind="listItemProps"
          :subtitle="item.raw.location"
        />
      </template>
    </v-autocomplete>

    <div
      v-for="provider_id in subsidy.provider_ids"
      :key="provider_id"
      class="mb-6"
    >
      <FavoriteCard
        :active="true"
        :index="0"
        :length="1"
        :provider-id="provider_id"
        class="my-4"
        hide-toggle
      />
    </div>
  </div>
</template>

<script setup>
import FavoriteCard from '@/parent/components/favorites/FavoriteCard.vue';
import useApi from '@/shared/composables/useApi';

const { api: Api } = useApi();

const $bct = inject('translator');

const props = defineProps({
  child: { type: Object, default: null },
  subsidy: { type: Object, default: null },
});

const emit = defineEmits(['update:subsidy']);

const providerQuery = ref(null);
const searchedProviders = ref([]);
const selectedProvider = ref(null);

const searchProviders = () => {
  Api.publicApi.provider.index({ query: providerQuery.value }, (resp) => {
    searchedProviders.value = resp.data;
  });
};

const setProvider = (provider) => {
  emit('update:subsidy', {
    ...props.subsidy,
    provider_ids: provider ? [provider.id] : [],
  });
};

watch(providerQuery, (newVal) => {
  if (newVal) {
    searchProviders();
  }
});
</script>
